import React from 'react';
import PropTypes from 'prop-types';
import { Controller, useFormContext } from "react-hook-form";
import ErrorMessage from './ErrorMessage';

const SelectInput= ({name, options, children, placeholder, onChange }) => {
  const { control} = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      render={({
        field, //{ onChange, onBlur, value, name, ref }
        fieldState: { invalid, isTouched, isDirty, error },
        formState,
      }) => {
        const _onChange = typeof onChange === 'function' ? onChange : field.onChange
        return (
          <div className="form-floating mb-3">
            <select
              value={field.value}
              onChange={_onChange}
              id={field.name}
              className={`form-select form-control ${isTouched && invalid ? "is-invalid" : ""}`}
              placeholder={placeholder}
            >
              {
                options ? 
                  <>
                    <option value="">{placeholder}</option>
                    {
                      options.map(o => <option value={o} key={o}>{o}</option>)
                    }
                  </> :
                  children
              }
            </select>
            <label htmlFor={field.name}>{placeholder}</label>
            <ErrorMessage error={error}/>
          </div>
        )
      }}
    />
  )
}

SelectInput.defaultProps = {};

SelectInput.propTypes = {
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  options: PropTypes.array,
};

export default SelectInput;